<div
  class="modal {{ options && options.classModifier ? 'modal--' + options.classModifier : '' }}"
  #modalContainer
  animate.enter="modal-enter"
  [class.modal-leave]="closed"
  (animationend)="onAnimationModalDone($event)"
  role="dialog"
  aria-modal="true"
  aria-labelledby="modalLabel"
>
  <ng-template modalContentHost></ng-template>
</div>

<div
  class="modal-backdrop"
  [ngClass]="{ 'modal-backdrop--darker': options?.color }"
  animate.enter="fade-in"
  [class.fade-out]="closed"
  (click)="onBackdropClick()"
></div>
